import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  namespaced: true,
  state: {
    albaranActivoMaterial: {},
    albaranActivoMaterials: [],
    total: 0
  },
  getters: {
    albaranActivoMaterial(state) {
      return state.albaranActivoMaterial;
    },
    list(state) {
      return state.albaranActivoMaterials;
    },
    listTotal(state) {
      return state.total;
    }
  },
  mutations: {
    setAlbaranActivoMaterial(state, albaranActivoMaterial) {
      state.albaranActivoMaterial = albaranActivoMaterial;
    },
    setList(state, albaranActivoMaterials) {
      state.albaranActivoMaterials = albaranActivoMaterials;
    },
    setListTotal(state, total) {
      state.total = total;
    }
  },
  actions: {
    async get({ commit }, id) {
      const response = await axios.get(`${url}/albaran-activo-materials/${id}?populate=*`);
      commit("setAlbaranActivoMaterial", response.data.data);
      return response.data.data;
    },
    async list({ commit }, params) {
      const queryParams = {
        populate: '*'
      };

      // Construir filtros
      const filters = {};
      
      // Filtro de búsqueda
      if (params.query) {
        filters.$or = [
          { "albaran_activo.numero": { $containsi: params.query } },
          { "activo.numero_serie": { $containsi: params.query } }
        ];
      }

      // Filtro de estado
      if (params.estado && params.estado !== "Todos") {
        if (Array.isArray(params.estado)) {
          filters.estado = { $in: params.estado };
        } else {
          filters.estado = params.estado;
        }
      }

      // Filtro por albarán
      if (params.albaranActivoId) {
        filters.albaran_activo = params.albaranActivoId;
      }

      // Añadir filtros a los parámetros de consulta si hay alguno activo
      if (Object.keys(filters).length > 0) {
        queryParams.filters = filters;
      }

      // Añadir ordenamiento si está presente
      if (params.sort) {
        queryParams.sort = params.sort;
      }

      // Añadir paginación si está presente
      if (params.pagination?.page) {
        queryParams['pagination[page]'] = params.pagination.page;
      }
      if (params.pagination?.pageSize) {
        queryParams['pagination[pageSize]'] = params.pagination.pageSize;
      }

      const response = await axios.get(`${url}/albaran-activo-materials`, { params: queryParams });
      commit("setList", response.data.data);
      commit("setListTotal", response.data.meta.pagination.total);
      return response.data.data;
    },
    async add({ commit }, data) {
      const response = await axios.post(`${url}/albaran-activo-materials`, { data });
      return response.data.data;
    },
    async update({ commit }, { id, data }) {
      const response = await axios.put(`${url}/albaran-activo-materials/${id}`, { data });
      return response.data.data;
    },
    async destroy({ commit }, id) {
      const response = await axios.delete(`${url}/albaran-activo-materials/${id}`);
      return response.data.data;
    }
  }
}; 